export default {
  status: '',
  user: {},
  twoFactorSetup: {
    required: false,
    state: 'completed',
    completed: true,
    setupRequired: false,
  },
  isApiKey: false,
  isImpersonating: false,
  access: [],
  primaryScopeIds: [],
  primaryTenantIds: [],
  tenantId: null,
  tenantIdThemeSetting: null,
};
